import Link from "next/link";
import { Trans, useTranslation } from "next-i18next";

import { Message } from "@/components/elements";
import { LINKS } from "@/constants/links";
import { useCart } from "@/hooks/useCart";
import { useProducts } from "@/hooks/useProducts";
import { toTitleCase } from "@/utils/helpers";

import styles from "./InactiveProductWarning.module.css";

export const InactiveProductWarning = () => {
  const products = useProducts();
  const { cart } = useCart();
  const { t } = useTranslation();

  const getProductName = (brand, title) => {
    return `${toTitleCase(brand)} ${t(title)}`;
  };

  const inactiveProducts = cart.products.reduce((result, cartItem) => {
    const product = products?.data?.productsById[cartItem.id];

    if (product?.status === "inactive") {
      const { brand, title } = product;

      return [
        ...result,
        {
          name: getProductName(brand, title),
          id: cartItem.id,
          category: product.category,
        },
      ];
    }

    return result;
  }, []);

  if (inactiveProducts.length === 0) {
    return null;
  }

  return (
    <div data-testid="inactive-product-warnings">
      {inactiveProducts.map(({ id, name, category }) => {
        return (
          <Message type="warning" key={id} className={styles.message}>
            <Trans
              i18nKey="product_inactive"
              values={{ name }}
              components={{
                shopLink: <Link href={getCategoryLink(category)} />,
              }}
            />
          </Message>
        );
      })}
    </div>
  );
};

const getCategoryLink = (category) => {
  switch (category) {
    case "soap":
      return LINKS.SHOP_SOAP;
    case "laundry":
      return LINKS.SHOP_LAUNDRY;
    case "cleaning":
      return LINKS.SHOP_CLEANING;
    default:
      return LINKS.SHOP;
  }
};
